package com.essntl.features.crm.ui

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.crm.domain.model.OrganizationListModel

data class CRMState(
    val getOrganizationList: State<List<OrganizationListModel>> = State(),
    val selectedContactTab: Int = 0,
    val searchText: String = "",
)